import { Card, CardHeader, Divider, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PropertyList } from '../../../../components/atoms/property-list';
import { PropertyListItem } from '../../../../components/atoms/property-list-item';

interface Props {
  name: string;
}

export const Info = ({ name }: Props) => {
  const { t } = useTranslation(['billingGroups', 'destinationGroups']);

  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const align = mdDown ? 'vertical' : 'horizontal';

  return (
    <Card variant="outlined">
      <CardHeader title={t('billingGroups:details.info')} />
      <Divider />
      <PropertyList>
        <PropertyListItem
          align={align}
          width={150}
          label={t('destinationGroups:table.name')}
          value={name}
        />
      </PropertyList>
    </Card>
  );
};
